import React from "react";
import Column from "@amzn/meridian/column";
import { AllegroIsHereText } from "../../shared";
import GetStartedButton from "./getStartedButton";

const AllegroIsHereNonDesktop = () => {
  return (
    <Column spacing="500">
      <AllegroIsHereText fontType={"d50"}></AllegroIsHereText>
      <GetStartedButton
        targetElement={"heresHowItWorksNonDesktopElement"}
      ></GetStartedButton>
    </Column>
  );
};

export default AllegroIsHereNonDesktop;
